import { render, staticRenderFns } from "./tagging-service-audit-details.component.vue?vue&type=template&id=137cd881"
import script from "./tagging-service-audit-details.component.vue?vue&type=script&lang=ts"
export * from "./tagging-service-audit-details.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports